// extracted by mini-css-extract-plugin
export default {"title":"njvg48","bold":"x1Yasi"};